<template>
  <div>
    <multiselect
      v-model="value"
      :options="options"
      :multiple="true"
      :searchable="true"
      :taggable="true"
      @input="onChange"
      track-by="id"
      label="name"
      :select-label="''"
      :deselect-label="''"
      v-bind:placeholder="this.placeholder"
      ><template slot="selection" slot-scope="{ values, search, isOpen }"
        ><span
          class="multiselect__single"
          v-if="values.length>1 &amp;&amp; !isOpen"
          >{{ values.length }} {{ type }} geselecteerd</span
        ></template
      ></multiselect
    >
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { mapActions } from "vuex";

export default {
  name: "IndoorSearch",
  components: { Multiselect },
  data() {
    return {
      options: [
        {
          id: "indoor",
          name: "indoor"
        },
        {
          id: "outdoor",
          name: "outdoor"
        }
      ],
      filtername: "indoor",
      placeholder: "Indoor en outdoor"
    };
  },
  computed: {
    value: {
      get() {
        const values = this.$store.state.search[this.filtername];
        return this.options.filter(option => values.includes(option["id"]));
      },
      set() {}
    }
  },
  methods: {
    onChange(value) {
      const selected = value.map(item => item.id);
      const routename = this.$router.currentRoute.name;
      this.update_search({ selected, filtername: this.filtername, routename });
      if (routename !== "Home" && routename !== "TodoSearchResults")
        this.$router.push({ name: "Home" });
    },
    ...mapActions(["update_search"])
  }
};
</script>

<!-- TODO: overwrite/replace -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
/* .filter {
  margin: 0.75rem;
} */
.multiselect {
  margin-top: 1.25rem;
  height: 2.5rem;
  border-style: solid;
  border-radius: 0.5rem;
  border-color: transparent;
  font-family: "open sans", sans-serif;
  font-size: 0.875rem;
  border-width: 1px;
  width: 100%;
}

.multiselect__single {
  font-family: "open sans", sans-serif;
  font-size: 0.875rem;
  background-color: transparent;
}

.multiselect__input::placeholder,
.multiselect__placeholder {
  color: rgba(200, 209, 220, 1);
  padding-left: 0.5rem;
}

.multiselect__tags {
  height: 2.5rem;
  background-color: #f7fafc;
  border-style: solid;
  border-radius: 0.5rem;
  border-color: #4a5568;
}

.multiselect__tag {
  border-color: purple;
  border-style: dashed;
  border-width: 1px;
  background-color: #f7fafc;
  color: gray;
}

.multiselect__tag-icon:hover {
  background-color: red;
}

.multiselect__content {
  background: lightgray;
}

.multiselect__option:hover {
  background: gray;
}
.multiselect__option--highlight {
  background: gray;
}
.multiselect__option--selected {
  background: lightgray;
}

.multiselect__select {
  right: 0;
  padding-left: 1rem;
  padding-right: 1rem;
  width: 4rem;
}
</style>
